import { type HTMLTableRowProps } from '@/lib/types';
import StyledItemTableRow from './StyledItemTableRow';
import type React from 'react';
import { useRef } from 'react';

type ClickableItemTableRowProps = HTMLTableRowProps & {
  onClick: (event: React.MouseEvent<HTMLTableRowElement>) => void;
  selected: boolean;
  disabled: boolean;
};

const ClickableItemTableRow = ({
  onClick,
  disabled,
  ...props
}: ClickableItemTableRowProps) => {
  const trRef = useRef<HTMLTableRowElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLTableRowElement>): void => {
    if (disabled) {
      return;
    }

    if (trRef.current == null || !(e.target instanceof HTMLElement)) {
      return;
    }

    // Don't fire click event when a button, checkbox or <a> is clicked
    if (
      !e.target.classList.contains('MuiButtonBase-root') &&
      !e.target.classList.contains('PrivateSwitchBase-input') &&
      !(e.target instanceof HTMLAnchorElement)
    ) {
      onClick(e);
    }
  };

  return <StyledItemTableRow onClick={handleClick} {...props} ref={trRef} />;
};

export default ClickableItemTableRow;
